import styled from 'styled-components';
import { Button } from '@rsos/base-components';
import { EVENT_PANE_MARGIN } from './EventPane.styles';

export const StyledEventPaneTabs = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: hidden;
`;

export const ButtonGroup = styled.div`
  height: 50px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 1px solid ${props => props.theme.colors.lightLineDivider};
  margin: ${EVENT_PANE_MARGIN}px ${EVENT_PANE_MARGIN}px 0;
  padding-bottom: 8px;
`;

export const TabContent = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
  overflow-y: auto;
  box-sizing: border-box;
  padding: 16px;
`;

export const PillButton = styled(Button).attrs(({ active }) => ({
  size: 'small',
  btnType: active ? 'secondary' : 'invisible',
}))`
  width: 108px;
  height: 36px;
  border-radius: 3px;
  border: 0;
  outline: 0;

  ${({ theme, active }) => `
    ${
      theme.colors.name === 'light' && active
        ? `
      background: ${theme.colors.lightLineDivider};
    `
        : `
      &:hover {
        background: ${theme.colors.foreground};
      }
    `
    }
  `}

  ${({ theme, active, hidden }) => {
    if (hidden) {
      return `
      display: none;
    `;
    }

    if (theme.colors.name !== 'light' && active) {
      return `
        background: ${theme.colors.tabHighlight};
      `;
    }
  }}
`;
